var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto transparent",attrs:{"flat":"","max-width":"950px"}},[_c('HeadRoot',{attrs:{"title":"Teams Admin","length":0,"btn_txt":"","btn_to":""}}),_c('List',{staticClass:"mt-8"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }